# TODO: this doesn't actually work.
# Deriving a new error type is much more complicated than this.
module.exports = class AssertionError extends Error
